<template>
	<div class="userBox">
		<div class="login-left">
			<img :src="baseInfo.login_logo" class="login-logo" width="60" height="60" />
			<div class="login-title">
				<p class="yx-color-text-primary yx-pingfang-semibold" style="font-size: 36px">{{ baseInfo.company_name }}</p>
				<p class="yx-color-text-regular fz-24">让团长生意更好做</p>
			</div>
		</div>
		<!--账户密码登录 start-->
		<div class="login-right">
			<div class="login-box" v-if="isShow">
				<h1 class="fz-24 yx-pingfang-Medium mb-24">登录</h1>
				<el-tabs v-model="loginType">
					<el-tab-pane label="验证码登录" name="1"></el-tab-pane>
					<el-tab-pane label="密码登录" name="0"></el-tab-pane>
				</el-tabs>
				<!--账户密码登录 start-->
				<template v-if="loginType === '1'">
					<div :class="error.mobile ? 'error' : ''">
						<el-input type="text" placeholder="请输入11位手机号" size="medium" maxlength="11" v-model.trim="user.mobile">
							<i class="i-mobile" slot="prefix"></i>
						</el-input>
						<div class="error-msg">
							<p class="font-h6-regular yx-color-danger">{{ error.mobile }}</p>
						</div>
					</div>
					<div :class="error.code ? 'error' : ''">
						<div class="flex-row">
							<span class="special">
								<el-input type="text" placeholder="请输入验证码" size="medium" v-model="user.code"></el-input>
							</span>
							<el-button type="primary" plain class="ml-12 flex-1" size="medium" @click="clickSendCode" :disabled="!!sendCodeTimeText">
								{{ sendCodeTimeText ? sendCodeTimeText : sendCodeText }}
							</el-button>
						</div>
						<div class="error-msg">
							<p class="font-h6-regular yx-color-danger">{{ error.code }}</p>
						</div>
					</div>
					<div class="flex-row mt-12" style="height: 48px">
						<el-button type="primary" size="medium" class="flex-1" :disabled="!canLogin" @click="login" :loading="loading">登录</el-button>
					</div>
				</template>
				<template v-else>
					<div :class="error.mobile ? 'error' : ''">
						<el-input type="text" placeholder="请输入11位手机号" size="medium" maxlength="11" v-model.trim="user.mobile">
							<i class="i-mobile" slot="prefix"></i>
						</el-input>
						<div class="error-msg">
							<p class="font-h6-regular yx-color-danger">{{ error.mobile }}</p>
						</div>
					</div>
					<div :class="error.password ? 'error' : ''">
						<el-input :type="pwdType ? 'password' : 'text'" placeholder="请输入密码" size="medium" v-model="user.password">
							<i class="i-pwd" slot="prefix"></i>
							<i class="cursor-pointer" :class="pwdType ? 'i-eye-close' : 'i-eye-open'" slot="suffix" @click="changePwdType"></i>
						</el-input>
						<div class="error-msg">
							<p class="font-h6-regular yx-color-danger">{{ error.password }}</p>
						</div>
					</div>
					<div class="flex-row mt-12" style="height: 48px">
						<el-button type="primary" size="medium" class="flex-1" :disabled="!canLogin" @click="login" :loading="loading">登录</el-button>
					</div>
				</template>
				<div class="cursor-pointer flex-row-align-center mt-14 font-h4-regular fz-14 yx-color-primary" v-if="loginType === '0'">
					<p @click="forgetFun('设置密码')">设置密码</p>
					<p class="line"></p>
					<p @click="forgetFun('忘记密码')">忘记密码</p>
				</div>
				<div>
					<div class="cursor-pointer flex-row-align-center mt-20 font-h4-regular fz-14 yx-color-primary" v-if="linkId" @click="skipRegister">
						注册
					</div>
				</div>
			</div>
			<setting @goLogin="goLogin" :mobile="user.mobile" :title="title" v-else></setting>
			<div class="footer flex-row flex-align-center">
				<a
					href="https://xyt.xcc.cn/getpcInfo?sn=1498580107923533824&language=CN&certType=8&url=*.chaoyongbushou.com"
					target="_blank"
					style="position: relative"
					class="mr-20"
				>
					<div style="width: 100%; height: 100%; position: absolute; top: 0; left: 0"></div>
					<embed
						src="https://program.xinchacha.com/web/1498580107923533824=*.chaoyongbushou.com.svg"
						width="103"
						height="38"
						type="image/svg+xml"
						pluginspage="//www.adobe.com/svg/viewer/install/"
					/>
				</a>
				<a href="https://beian.miit.gov.cn/" target="_blank">备案号：{{ domainRecordNo || baseInfo.domain_record_no || '浙ICP备2022008875号' }}</a>
			</div>
		</div>

		<ChooseGroup ref="chooseGroup" :tenantInfoList="tenantInfoList" @choose="chooseGroup" :showClose="false"></ChooseGroup>
	</div>
</template>

<script>
import { sendCode, bindWxLogin, checkPass, preLogin, preSmsLogin, confirmLogin } from '@/api/user';
import * as types from '@/store/mutation-types';
import { isValidPassword, isTel } from '@/utils/reg';
import mixin from './mixin';
import setting from './components/setting.vue';
import { tzRoleType } from '@/utils/dataMap';
import ChooseGroup from '@/components/business/chooseTenant';
import md5 from 'js-md5';
import { accountInfo } from '@/api/common';

export default {
	name: 'login',
	mixins: [mixin],
	components: {
		setting,
		ChooseGroup,
	},
	data() {
		return {
			seller_token: '',
			user: {
				mobile: '',
			},
			error: {
				mobile: '',
				password: '',
				code: '',
			},
			sendCodeText: '发送验证码',
			sendCodeTime: '',
			timer: null,
			loginType: '1',
			isShow: true,
			loading: false,
			canLogin: false,
			pwdType: true,
			tenantInfoList: [],
			linkId: '',
		};
	},
	computed: {
		sendCodeTimeText() {
			return this.sendCodeTime ? this.sendCodeTime + 's' : '';
		},
		domainRecordNo() {
			const hosts = location.host.split('.');
			hosts.shift();
			const domains = {
				'vipsaas.com ': 8,
			};
			const no = domains[hosts.join('.')] || '';
			return no ? `浙ICP备2021010797号-${no}` : '';
		},
		isPwdLogin({ loginType }) {
			return loginType === '0';
		},
		checkLoginDataStatus({ loginType, user }) {
			return { loginType, ...user };
		},
	},
	watch: {
		checkLoginDataStatus: {
			handler() {
				this.canLogin = this.validLoginData();
			},
			deep: true,
		},
	},
	mounted() {
		this.linkId = this.$route.query.linkId;
		window.addEventListener('keyup', this.onSubmit);
	},
	beforeDestroy() {
		window.removeEventListener('keyup', this.onSubmit);
	},
	methods: {
		validLoginData() {
			return this.loginType === '0' ? !!(this.user.mobile && this.user.password) : !!(this.user.mobile && this.user.code);
		},
		clearTimer() {
			clearInterval(this.timer);
			this.timer = null;
		},
		startTimer() {
			if (this.timer) {
				// 倒计时存在的时候，不要重复开启
				return;
			}
			this.timer = setInterval(() => {
				this.sendCodeTime--;
				if (this.sendCodeTime <= 0) {
					this.clearTimer();
				}
			}, 1000);
		},
		clickSendCode() {
			if (!this.user.mobile) {
				this.error.mobile = '请输入手机号';
			} else if (!isTel.test(this.user.mobile)) {
				this.error.mobile = '手机号输入错误';
			} else {
				this.error.mobile = '';
			}
			// 判断是否存在输入错误
			if (this.error.mobile) {
				return false;
			}
			const params = {
				mobile: this.user.mobile,
			};
			sendCode(params)
				.then(res => {
					if (res.code === 0) {
						// 短信验证码发送成功
						this.sendCodeTime = 60;
						this.startTimer();
					}
				})
				.catch(e => {});
		},
		validUserInfo() {
			if (!this.user.mobile) {
				this.error.mobile = '请输入手机号';
			} else if (!isTel.test(this.user.mobile)) {
				this.error.mobile = '手机号输入错误';
			} else {
				this.error.mobile = '';
			}
			if (this.isPwdLogin) {
				if (!this.user.password) {
					this.error.password = '请输入密码';
				} else if (this.user.password.length < 6 || this.user.password.length > 16) {
					this.error.password = '请输入6~16位密码,区分大小写';
				} else {
					this.error.password = '';
				}
				// 判断是否存在输入错误，没有错误返回true，有错误返回false
				if (this.error.mobile || this.error.password) {
					return false;
				}
				return true;
			} else {
				if (!this.user.code) {
					this.error.code = '请输入验证码';
				} else {
					this.error.code = '';
				}
				if (this.error.mobile || this.error.code) {
					return false;
				}
				return true;
			}
		},
		async login() {
			this.loading = true;
			const valid = this.validUserInfo();
			if (!valid) {
				this.loading = false;
				return;
			}
			if (this.isPwdLogin) {
				const res = await checkPass({ mobile: this.user.mobile });
				if (res.code !== 0) return (this.loading = false);
				if (res.code === 0 && res.data.isSetPwd === 0) {
					this.$message.error('请先设置密码后登录');
					this.loading = false;
					return;
				}
			}
			try {
				const { mobile, password, code: sms_code } = this.user;
				const {
					code,
					data: { tenantInfoList, accessToken },
				} = this.isPwdLogin ? await preLogin({ mobile, password: md5(password) }) : await preSmsLogin({ mobile, sms_code: sms_code });
				if (code === 0) {
					// 单租户直接登录
					if (accessToken) {
						const [{ tenantId, roleList = [], openIds = [], userId }] = tenantInfoList;
						this.handleTenantLogin({ accessToken, tenantId, roleList, openIds, userId });
					} else {
						// 没有accessToken则说明是说租户账号，展示租户列表选择登录
						this.tenantInfoList = tenantInfoList;
						this.$refs.chooseGroup.show();
					}
				} else {
					this.loading = false;
				}
			} catch (error) {
				this.loading = false;
			}
		},
		skipRegister() {
			this.$router.push({
				path: '/register',
				query: this.$route.query,
			});
		},
		onSubmit(e) {
			if (e.keyCode === 13 && this.canLogin && !this.loading) {
				this.login();
			}
		},
		// 选择登录的租户团队
		async chooseGroup({ userId, tenantId, preAuthSign } = {}) {
			const {
				code,
				data: { accessToken, roleList, openIds },
			} = await confirmLogin({ userId, tenantId, preAuthSign });
			if (code === 0) {
				this.handleTenantLogin({ accessToken, tenantId, roleList, openIds, userId });
				this.$refs.chooseGroup.hide();
			}
		},
		/**
		 * @description: 处理租户登录
		 * @param {*} accessToken 登录token
		 * @param {*} tenantId 租户ID
		 * @param {*} roleList 租户下用户的角色列表
		 * @param {*} openIds 租户下角色的媒体openIds
		 * @return {*}
		 * @acthor: Li Yong
		 * @Date: 2022-09-02 15:10:55
		 */
		async handleTenantLogin({ accessToken, tenantId, roleList, openIds, userId }) {
			await this.setData(accessToken, tenantId, roleList, userId);
			// 有linkId登录之后跳转回邀请商团协作页面
			// 没有绑定微信，跳转绑定微信页面
			// 没有linkId并有绑定微信跳转工作台
			// 获取php用户信息
			const { code, data } = await accountInfo({});
			if (code == 0) {
				// 更新配置字段
				this.$store.commit(types.USER_INFO, data);
			}
			if (this.linkId) {
				this.$router.replace({
					path: '/invite',
					query: {
						linkId: this.linkId,
						isLogin: 1,
					},
				});
			} else {
				// 回到工作台页面
				this.gotoIndex(openIds);
			}
		},
		setData(token, tenantId, roleList = [], userId) {
			return new Promise(async (rs, rj) => {
				try {
					// 保存token到cookie
					CookiesTools.setToken(token);
					// 设置登录态
					this.$store.commit(types.LOGIN_STATUS, true);
					this.$store.commit(types.TENANT_ID, tenantId);
					this.$store.commit(types.USER_ID, userId);
					this.$store.commit(types.BIND_ROLES, roleList);
					rs();
				} catch (error) {
					rj();
				}
			});
		},
		changePwdType() {
			this.pwdType = !this.pwdType;
		},
		forgetFun(value) {
			this.title = value;
			this.isShow = false;
		},
		goLogin() {
			this.user.password = '';
			this.isShow = true;
		},
	},
};
</script>

<style scoped lang="less">
@import '../../styles/login.less';
</style>
